module.exports = [
    {
        title: "CHARISMA",
        color: "#C31432",
        image: require("@/assets/images/icons/character-cards-gala/charisma.svg"),
        background: "rgba(196, 20, 50, 0.1)",
        border: "1px solid #C31432",
        slug: "charisma"
    },
    {
        title: "WISDOM",
        color: "#F29300",
        image: require("@/assets/images/icons/character-cards-gala/wisdom.svg"),
        background: "rgba(246, 157, 53, 0.1)",
        border: "1px solid #F29300",
        slug: "wisdom"
    },
    {
        title: "COMPASSION",
        color: "#FF7B91",
        image: require("@/assets/images/icons/character-cards-gala/compassion.svg"),
        background: "rgba(255, 123, 145, 0.1)",
        border: "1px solid #FF7B91",
        slug: "compassion"
    },
    {
        title: "INTELLIGENCE",
        color: "#67D8F3",
        image: require("@/assets/images/icons/character-cards-gala/intelligence.svg"),
        background: "rgba(103, 216, 243, 0.3)",
        border: "1px solid #67D8F3",
        slug: "intelligence"
    },
    {
        title: "STRENGTH",
        color: "#7140FF",
        image: require("@/assets/images/icons/character-cards-gala/strength.svg"),
        background: "rgba(113, 64, 255, 0.1)",
        border: "1px solid #7140FF",
        slug: "strength"
    },
    {
        title: "DEXTERITY",
        color: "#44CC88",
        image: require("@/assets/images/icons/character-cards-gala/dexterity.svg"),
        background: "rgba(68, 204, 136, 0.1)",
        border: "1px solid #44CC88",
        slug: "dexterity"
    },
];
